import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export function useDayMetrics(userId: string, selectedDate: string) {
  return useQuery({
    queryKey: ["dayMetrics", userId, selectedDate],
    queryFn: () =>
      api.getDayMetrics(userId, {
        type: "Summary",
        date: selectedDate,
      }),
    enabled: !!userId && !!selectedDate,
  });
}
